import { ClaimGroup as BaseClaimGroup } from '@rd-web-markets/shared/dist/models/ClaimGroup';
import { isUserCustomer } from '@rd-web-markets/shared/dist/util/user/userUtils';
export class ClaimGroup extends BaseClaimGroup {
  isSmeOrRdec() {
    var _this$claimGroup$rate, _this$claimGroup$rate2, _this$claimGroup$rate3;
    return ((_this$claimGroup$rate = this.claimGroup.rate_types_qualified_for) === null || _this$claimGroup$rate === void 0 ? void 0 : _this$claimGroup$rate.sme) || ((_this$claimGroup$rate2 = this.claimGroup.rate_types_qualified_for) === null || _this$claimGroup$rate2 === void 0 ? void 0 : _this$claimGroup$rate2.rdec) || ((_this$claimGroup$rate3 = this.claimGroup.rate_types_qualified_for) === null || _this$claimGroup$rate3 === void 0 ? void 0 : _this$claimGroup$rate3.sme_and_rdec) || false;
  }
  isSmeAndRdec() {
    var _this$claimGroup$rate4;
    return ((_this$claimGroup$rate4 = this.claimGroup.rate_types_qualified_for) === null || _this$claimGroup$rate4 === void 0 ? void 0 : _this$claimGroup$rate4.sme_and_rdec) || false;
  }
  getOverviewLink(user) {
    var _this$claimGroup$comp;
    const isCustomer = isUserCustomer(user);
    if (isCustomer && (_this$claimGroup$comp = this.claimGroup.company) !== null && _this$claimGroup$comp !== void 0 && _this$claimGroup$comp.dashboard_type) {
      const basePath = "/customer/claim_groups/".concat(this.claimGroup.id);
      return this.claimGroup.company.dashboard_type === 'business_unit_intensity_breakdown' ? "".concat(basePath, "/regular_realtime_dashboard/").concat(this.claimGroup.company_id) : "".concat(basePath, "/dashboard/").concat(this.claimGroup.company_id);
    } else {
      return super.getOverviewLink(user);
    }
  }
  static load(claimGroupJsonObject) {
    return new ClaimGroup(claimGroupJsonObject);
  }
}